Ext.define('SA.data.LocationsQuery', {
    alias: 'query.locations',
    extend: 'SA.data.Query',

    fieldsProperty: 'select',
    resource: 'data/location',
    whereProperty: 'locationSeries'
});